// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__4oh6c","table":"Table_table__i0aVC","row":"Table_row__+x5RY","col":"Table_col__mkQgO","status":"Table_status__LlWfA"};